import { createStyles } from '../withStyles';
const styles = (theme) => createStyles({
    root: {
        lineHeight: 1.5,
        marginTop: theme.spacing(0.5),
        fontSize: theme.fontSizes.xs,
        color: theme.palette.text.secondary,
        '&$error': {
            color: theme.palette.error.main,
        },
    },
    error: {},
    indent: {
        paddingLeft: theme.spacing(2),
    },
    success: {
        color: theme.palette.progress.dark,
    },
});
export default styles;
//# sourceMappingURL=InputHelperText.styles.js.map